/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentStatus } from '../models';

export const getAuthorizePaymentErrorMessage = (
  errorResponse: HttpErrorResponse,
): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  let errorMessage = errorResponse?.error;

  if (
    Array.isArray(errorResponse?.error?.errors) &&
    errorResponse.error.errors.length > 0
  ) {
    errorMessage = errorResponse.error.errors[0].message as string;
  }

  return errorMessage;
};

export const getUpdateExpirationDateErrorMessage = (
  errorResponse: HttpErrorResponse,
): string => {
  let errorMessage = (errorResponse.error?.error ??
    errorResponse.error) as string;

  if (Array.isArray(errorResponse.error)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    errorMessage = (errorResponse.error[0]?.message ??
      errorResponse.error[0]) as string;
  }

  return errorMessage;
};

export function getExecutePaymentErrorState(error: HttpErrorResponse): {
  status: PaymentStatus;
  error: string;
} {
  const result = {
    status: PaymentStatus.TIMEOUT,
    error: null,
  };

  if (error.status < 500) {
    result.status = PaymentStatus.FAILED;
    result.error = getAuthorizePaymentErrorMessage(error);
  }

  return result;
}

export function getEditableAmountErrorMessage(
  hasDocumentsFromMultipleAccounts: boolean,
  isZeroDollarPaymentEnabled: boolean,
) {
  let errorKey: string;
  if (hasDocumentsFromMultipleAccounts) {
    errorKey = isZeroDollarPaymentEnabled
      ? 'ARC_PAYMENT_ZERO_DOLLAR_ON_EDIT_PAYABLE_ERROR_LINKED_ACCOUNTS'
      : 'ARC_PAYMENT_ZERO_DOLLAR_OFF_EDIT_PAYABLE_ERROR_LINKED_ACCOUNTS';
  } else {
    errorKey = isZeroDollarPaymentEnabled
      ? 'ARC_PAYMENT_ZERO_DOLLAR_ON_EDIT_PAYABLE_ERROR'
      : 'ARC_PAYMENT_ZERO_DOLLAR_OFF_EDIT_PAYABLE_ERROR';
  }
  return errorKey;
}
